module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAABKklEQVRIx2NgyLYfGDRq8ajF2FBlMsPkVQzzT4MQkAHkkmFI6CRDkpDu7EaeFRcZlt6WX3NYc91uIAPIBQqSag7Dz7tixKMDF52Zlt3kWX5Jfd2ekB0zInZOAzKAXKAgUIoko0iz2G/bXI11e+w2rwraPrPiQE39oTIgw2zjRqU1B4BSNLRYcvVxoP8K9zf6b58DtN5605qA7XOK9zeIrDwDlKKtxazLrmut29V6pAhoKxC1HSkEcoGCtLUYGJ5yaw4zLr0FjN3sfa2VB2tid00EcoGCtA1qSOKSXn00Z2+b/JpDQASMaaBfyUlcr0qUSEI13ZXsy64Cc5H4qhNABGRwLLsKFCTVHIZHthqkovWhge4ti8VnnQQiIAPIJcMQciymChq1ePhbDADH+vtSzqevGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/et.png
// module id = 821
// module chunks = 0